function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#mfaEmail_svg__clip0_7937_323960)"
}, React.createElement("path", {
  d: "M24.952 7.8H5.048a.848.848 0 00-.848.847v13.905c0 .468.38.848.848.848h19.904c.468 0 .848-.38.848-.848V8.647a.848.848 0 00-.848-.847z",
  fill: "#E5F1FF"
}), React.createElement("path", {
  d: "M5.048 7.8a.848.848 0 00-.848.847v13.905c0 .468.38.848.848.848h19.904c.468 0 .848-.38.848-.848V8.647a.848.848 0 00-.848-.847H5.048zM23.398 9L15 14.886 6.601 9h16.797zM24.6 22.199H5.4V9.624l9.114 6.386c.292.205.68.205.972 0L24.6 9.624v12.575z",
  fill: "#006FFF"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "mfaEmail_svg__clip0_7937_323960"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(.6 .6)",
  d: "M0 0h28.8v28.8H0z"
})));

var SvgMfaEmail = function SvgMfaEmail(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzc5MzdfMzIzOTYwKSI+CjxwYXRoIGQ9Ik0yNC45NTIzIDcuNzk5OEg1LjA0NzU5QzQuNTc5NDUgNy43OTk4IDQuMTk5OTUgOC4xNzkzMSA0LjE5OTk1IDguNjQ3NDVWMjIuNTUyMkM0LjE5OTk1IDIzLjAyMDMgNC41Nzk0NSAyMy4zOTk4IDUuMDQ3NTkgMjMuMzk5OEgyNC45NTIzQzI1LjQyMDQgMjMuMzk5OCAyNS43OTk5IDIzLjAyMDMgMjUuNzk5OSAyMi41NTIyVjguNjQ3NDVDMjUuNzk5OSA4LjE3OTMxIDI1LjQyMDQgNy43OTk4IDI0Ljk1MjMgNy43OTk4WiIgZmlsbD0iI0U1RjFGRiIvPgo8cGF0aCBkPSJNNS4wNDc1OSA3Ljc5OThDNC41Nzk0NSA3Ljc5OTggNC4xOTk5NSA4LjE3OTMxIDQuMTk5OTUgOC42NDc0NVYyMi41NTIyQzQuMTk5OTUgMjMuMDIwMyA0LjU3OTQ1IDIzLjM5OTggNS4wNDc1OSAyMy4zOTk4SDI0Ljk1MjNDMjUuNDIwNCAyMy4zOTk4IDI1Ljc5OTkgMjMuMDIwMyAyNS43OTk5IDIyLjU1MjJWOC42NDc0NUMyNS43OTk5IDguMTc5MzEgMjUuNDIwNCA3Ljc5OTggMjQuOTUyMyA3Ljc5OThINS4wNDc1OVpNMjMuMzk3NSA5LjAwMUwxNSAxNC44ODU4TDYuNjAxMTUgOS4wMDFIMjMuMzk3NVpNMjQuNTk5OSAyMi4xOTg2SDUuMzk5OTVWOS42MjM4TDE0LjUxMzUgMTYuMDEwMUMxNC44MDU1IDE2LjIxNDggMTUuMTk0NCAxNi4yMTQ4IDE1LjQ4NjQgMTYuMDEwMUwyNC41OTk5IDkuNjIzOFYyMi4xOTg2WiIgZmlsbD0iIzAwNkZGRiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzc5MzdfMzIzOTYwIj4KPHJlY3Qgd2lkdGg9IjI4LjgiIGhlaWdodD0iMjguOCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNTk5ODU0IDAuNTk5NjA5KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgMfaEmail as ReactComponent };